export { default } from './FeaturedEventBlock';
export * from './FeaturedEventBlock';
